import * as React from "react";
import { useState, useEffect } from 'react';
import {
  makeStyles
} from "@material-ui/core";
import {ParticipantModel} from '../../../../../interface/iParticipant';
import CustomDataTable from './component/DataTable';
import { useSelector} from "react-redux";

type PropsFunction = (data: ParticipantModel[]) => void

const useStyles = makeStyles((theme) => ({
  root: {
    height: '400px',
    marginTop: theme.spacing(3),
  }
}));

const ParticipantsTable = React.forwardRef(
  (
    { setTagToolsTrigger, dotEditTags, dotRemoveParticipant, isMobile }: { setTagToolsTrigger: PropsFunction, dotEditTags: any, dotRemoveParticipant: any, isMobile: boolean },
    ref: React.Ref<any>
  ) => {
  
  ParticipantsTable.displayName = 'participant';

  const classes = useStyles();
  const [selRowIds, setSelection] = useState<string[]>([]);

  const tableRef = React.useRef<any>(null);

  const old_participants = useSelector((state: any) => state.experience.participants);
  const new_participants = useSelector((state: any) => state.liveParticipants.liveParticipants);
  const participants = new_participants ? new_participants : old_participants;
  const tableData = participants?.participants;

  useEffect(() => {
    if (!selRowIds.length) {
      setTagToolsTrigger([]);
      return;
    }
    const selRows: ParticipantModel[] = tableData.filter((c: any) => selRowIds.indexOf(c.participant_id) !== -1);
    setTagToolsTrigger(selRows);
  }, [selRowIds, setTagToolsTrigger]);

  React.useImperativeHandle(
    ref,
    () => ({
      setEmptySelParts() {
        setSelection([]);
        if (tableRef !== null && tableRef.current) {
          tableRef.current.clearAllSelRows();
        }
      }
    })
  );

  return (
    <div className={classes.root}>
      <CustomDataTable
        ref={tableRef}
        isMobile={isMobile}
        rows={tableData}
        onSelectionChange={(newSelection) => {
          setSelection(newSelection)
        }}
        dotEditTags={(participant: any) => dotEditTags(participant)}
        dotRemoveParticipant={(participant: any) => dotRemoveParticipant(participant)}
      />
    </div>
  );
});

export default ParticipantsTable;


